<template>
  <div>
    <u-modal id="createProject" link="Создать сервер" title="Создать сервер" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event">
      <ProjectCreate/>
    </u-modal>
    <button type="submit" class="btn btn-primary" @click="isModalOpen=true">Создать проект</button>

    <table class="table table-striped table-sm">
      <thead>
      <tr>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in projects"
          :key="index"
      >
        <td>{{row.name}}</td>
        <td>
          <router-link :to="{name: 'project', params: { id: row.id }}">Перейти</router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script setup>
import {computed, ref} from "vue";
import ProjectCreate from "@/views/projects/ProjectCreate";
const isModalOpen = ref()

import {useProjectStore} from '@/store/projects'
const projectStore = useProjectStore()

// project list
const projects = computed(() => projectStore.items)
projectStore.getList()
</script>
